import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type DuplicateFileMutationVariables = Types.Exact<{
  data: Types.DuplicateFileInput;
}>;


export type DuplicateFileMutation = { duplicateFile?: { file?: { id: string } | null } | null };


export const DuplicateFileDocument = /*#__PURE__*/ gql`
    mutation DuplicateFile($data: DuplicateFileInput!) {
  duplicateFile(data: $data) {
    file {
      id
    }
  }
}
    `;

export function useDuplicateFileMutation() {
  return Urql.useMutation<DuplicateFileMutation, DuplicateFileMutationVariables>(DuplicateFileDocument);
};